import { Grid } from "@mui/material";
import { withStyles } from "@mui/styles";

export const OMGridXL = withStyles((theme) => ({
  container: {
    maxWidth: theme.breakpoints.values.xl,
  },
}))(Grid);

export const OMGrid = OMGridXL;

export const OMGridLG = withStyles((theme) => ({
  container: {
    maxWidth: theme.breakpoints.values.lg,
  },
}))(Grid);

export const OMGridMD = withStyles((theme) => ({
  container: {
    maxWidth: theme.breakpoints.values.md,
  },
}))(Grid);
